module.exports = __webpack_public_path__ + "img/liyulong.8e44a7df.jpg";